import { Flex as MantineFlex, FlexProps } from '@mantine/core';
import { forwardRef } from 'react';

export interface ThemedFlexProps extends FlexProps {
  centered?: boolean;
  spaceBetween?: boolean;
  fullWidth?: boolean;
  fullHeight?: boolean;
}

const Flex = forwardRef<HTMLDivElement, ThemedFlexProps>(
  ({ centered = false, spaceBetween = false, fullWidth = false, fullHeight = false, justify, align, style, children, ...rest }, ref) => {
    const computedJustify = spaceBetween ? 'space-between' : centered ? 'center' : justify;
    const computedAlign = centered ? 'center' : align;

    return (
      <MantineFlex
        ref={ref}
        justify={computedJustify}
        align={computedAlign}
        style={{
          width: fullWidth ? '100%' : undefined,
          height: fullHeight ? '100%' : undefined,
          ...style,
        }}
        {...rest}
      >
        {children}
      </MantineFlex>
    );
  }
);

Flex.displayName = 'Flex';

export default Flex;
